export default {
    headers: {
        'duration-in-days': 'Duration in days',
        'start-date': 'Start date',
        'reason': 'Reason',
        'for-all-employee': 'for All Employee',
        'job-description': 'Job description',
        'employees': 'employees'
    },
    inputs: {
        'duration-in-days': 'Duration in days',
        'reason': 'Reason',
        'all-employees': 'All employees',
        'job-descriptions': 'Job descriptions'
    },
    'delete-message-holiday': 'Are you sure you want delete this holiday ?'
}